export const USER_PROFILE_LOGIN = 'USER_PROFILE_LOGIN'
export const USER_PROFILE_SET = 'USER_PROFILE_SET'
export const USER_PROFILE_LOGOUT = 'USER_PROFILE_LOGOUT'

export const LOADER_LOADING = 'LOADER_LOADING'
export const LOADER_NOT_LOADING = 'LOADER_NOT_LOADING'

// serial list
export const FILTER_SERIALS_SEARCH = 'FILTER_SERIALS_SEARCH'
export const FILTER_SERIALS_SELECT_CUSTOMER = 'FILTER_SERIALS_SELECT_CUSTOMER'
export const FILTER_SERIALS_SELECT_CITY = 'FILTER_SERIALS_SELECT_CITY'
export const FILTER_SERIALS_SELECT_COUNTRY = 'FILTER_SERIALS_SELECT_COUNTRY'

export const FILTER_DATE_RANGE = 'FILTER_DATE_RANGE'

// license expiry report
export const FILTER_REPORT_LICENSE_EXPIRY_DATE_RANGE = 'FILTER_REPORT_LICENSE_EXPIRY_DATE_RANGE'
export const FILTER_REPORT_LICENSE_EXPIRY_EXPIRES_IN_DAYS = 'FILTER_REPORT_LICENSE_EXPIRY_EXPIRES_IN_DAYS'
export const FILTER_REPORT_LICENSE_EXPIRY_EXPIRES_AGO_DAYS = 'FILTER_REPORT_LICENSE_EXPIRY_EXPIRES_AGO_DAYS'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js